import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import AppModalPlugin from './plugins/modal/AppModalPlugin.js';
import AppLazyImgPlugin from './plugins/lazyImg/AppLazyImgPlugin.js';

import { createApp } from './app';

Vue.use(VueCarousel);
Vue.use(VueCookies)
Vue.use(AppModalPlugin);
Vue.use(AppLazyImgPlugin);

const { app, router, store } = createApp(({ store, i18n }) => {
  i18n.locale = window.currentLocale.locale;

  store.commit('init', {
    host: location.origin,
    currentLocale: window.currentLocale,
    locales: window.locales
  });

});

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}

if (!window.__isSSR__) {

  Vue.mixin({
    beforeMount() {
      const { asyncData } = this.$options;
      if (asyncData) {
        this.dataPromise = asyncData({
          store: this.$store,
          route: this.$route
        });
      }
    }
  });
  app.$mount('#app');

} else {

  router.onReady(() => {
    router.beforeResolve((to, from, next) => {
      const matched = router.getMatchedComponents(to);
      const prevMatched = router.getMatchedComponents(from);
      let diffed = false;
      const activated = matched.filter((c, i) => {
        return diffed || (diffed = (prevMatched[i] !== c))
      });
      if (!activated.length) {
        return next();
      }
      Promise.all(activated.map((c) => {
        if (c.asyncData) {
          return c.asyncData({ store, route: to });
        }
      }))
        .then(() => next())
        .catch(next);
    })
    app.$mount('#app');
  });

}